import { Component, OnInit, SecurityContext } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute } from '@angular/router';
import { tick } from '@angular/core/testing';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-detail-blog-view',
  templateUrl: './detail-blog-view.component.html',
  styleUrl: './detail-blog-view.component.scss'
})
export class DetailBlogViewComponent implements OnInit {
  slug:string =""
  blogDetails:any={}
  constructor(
    private adminService: AdminService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta

  ) {
    // this.route.paramMap.subscribe(params => {
    //   this.slug = params.get('slug');  // Access the 'id' from the route
    // });
    // console.log("slug value",this.slug)
  }
  ngOnInit() {
    this.getBlogBySlugName('job-hunting-mistakes')

  }

  getBlogBySlugName(obj:any) {
    console.log("slig:",obj)
    let reqObj = {
      "slug": obj,
    }
    console.log('reqObj', reqObj)
    this.adminService.getBlogBySlugName(reqObj).subscribe((resp: any) => {
      if (resp.statusCode == 200) {
        this.blogDetails = resp.data.blog
 this.setMetaTags(this.blogDetails.meta_title,this.blogDetails.meta_description)

      }
    });
  }

  getAvatarImageUrl(path: string | undefined, name: string | undefined): string {
    console.log("patg:",path,name)
    if (path && name && path !== "NA" && name !== "NA") {
      return `${path}/${name}`;
    } else {
      return "assets/images/default.png"; // Default placeholder image URL
    }
  }

  sanitizeAndTrustHtml(html: string): any {
    const decodedHtml = this.sanitizer.sanitize(SecurityContext.HTML, html);
    const decodedText = document.createElement('textarea');
    decodedText.innerHTML = decodedHtml || '';
    return this.sanitizer.bypassSecurityTrustHtml(decodedText.value);
  }

  setMetaTags(title: string, description: string) {
    console.log("metaa:",title,description)
    this.titleService.setTitle(title);
    this.metaService.updateTag({ name: 'description', content: description });
  }

}
